<template>
  <div id="loading" v-if="is_loading">
    <div class="spinner"></div>
  </div>
  <div id="wrapper">
    <component :is="mainComponent" />
  </div>
</template>

<script setup>
import {computed, provide, ref} from "vue";
import AtusCpsLinkingCounts from "./components/AtusCpsLinkingCounts.vue";
import RotationPattern from "./components/RotationPattern.vue";

const props = defineProps({
  appName: { type: String },
  baseUrl: { type: String },
  csrfToken: { type: String }
});

let mainComponent = RotationPattern;

if (props.appName === 'atus_cps_linking_counts') {
  mainComponent = AtusCpsLinkingCounts;
}

const appDisplayName = computed(() => {
  return props.appName === 'atus_cps_linking_counts' ? 
                            'ATUS-CPS Linking Counts' : 
                            'Rotation Pattern Explorer Station (RoPES)'; 
});

const is_loading = ref(true);
const is_popup_open = ref(true);

provide("is_loading", is_loading);
provide("appName", props.appName);
provide("appDisplayName", appDisplayName);
provide("learnMoreUrl", null);
provide("learnMoreText", null);
provide('is_popup_open', is_popup_open);
</script>

<style lang="scss" scoped>
@use "./styles/variables.scss" as v;

p {
  font-size: 2em;
  text-align: center;
}

#wrapper{
  position: relative;
  margin: 0 auto;
  width: v.$page_width;
  display: flex;
  flex-direction: column;
  height: 100%;
}

#loading {
  z-index: 30;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  position: absolute;
  background-color: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
}

.spinner {
  border: 8px solid #f3f3f3;
  border-top: 8px solid #00263a;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
